import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";

export function DoiForm(){
    const sendDoiMail = useQuestionizerStore((state) => state.sendDoiMail);
    const setDoiWaitConfirm = useQuestionizerStore((state) => state.setDoiWaitConfirm);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const firstname = useQuestionizerStore((state) => state.firstname);
    const setFirstname = useQuestionizerStore((state) => state.setFirstname);
    const lastname = useQuestionizerStore((state) => state.lastname);
    const setLastname = useQuestionizerStore((state) => state.setLastname);
    const email = useQuestionizerStore((state) => state.email);
    const setEmail = useQuestionizerStore((state) => state.setEmail);
    const dataprotection = useQuestionizerStore((state) => state.dataprotection);
    const setDataprotection = useQuestionizerStore((state) => state.setDataprotection);
    const doi_confirm = useQuestionizerStore((state) => state.doi_confirm);

    const onBlur = () => {};

    const valid = () => dataprotection == true &&
      firstname &&  firstname?.length > 1 &&
      lastname && lastname?.length > 1 &&
      email && email?.length > 4;
    
    if (doi_confirm){
      return <> </>
    }

    if (success){
      return <div className="space-y-4 mb-8 bg-neutral p-8">
        <h2 className="mt-0">Vielen Dank!</h2>
		<p>Wir haben Ihnen eine E-Mail mit einem Bestätigungslink geschickt.</p>
      </div>
    }

    if (loading){
      return <div className="space-y-4 mb-8 bg-neutral p-8">
        <h2 className="mt-0">Einen Moment Bitte</h2>
      </div>
    }

    return (<form className="space-y-4 mb-8 bg-neutral p-8" aria-describedby="doi-form-description">
      <p id="doi-form-description">
        Um Ihnen diese Ergebnisse sicher und zuverlässig zur Verfügung stellen zu können, benötigen wir Ihre Kontaktdaten.
        Bitte tragen Sie Ihren Namen und Ihre E-Mail-Adresse ein. Wir senden ihnen anschließend eine Bestätigungs-E-Mail und nach Ihrer Zustimmung in der Mail erhalten Sie sofort Zugriff auf die vollständige Übersicht der Förderprogramme
      </p>
        <Input<string> id={"doi-1"} required={true} label="Vorname *" value={firstname} onBlur={onBlur} onChange={(value)=>{
          setFirstname(value);
        }} type="text"/>

        <Input<string> id={"doi-2"} required={true} label="Nachname *" value={lastname} onBlur={onBlur} onChange={(value)=>{
          setLastname(value);
        }} type="text"/>

        <Input<string> id={"doi-3"} required={true} label="E-Mail *" value={email} onBlur={onBlur} onChange={(value)=>{
          setEmail(value);
        }} type="email"/>

        <label className="flex ">
          <Checkbox required value={dataprotection == true} onBlur={onBlur} onChange={(value)=>{
            setDataprotection(value);
          }}/>		
          <span>
            Es gelten unsere <a target="_blank" href="https://foerderdata.de/datenschutzerklaerung/">Datenschutzbestimmungen</a>. Ja, ich bin einverstanden, von febis über Förder- und Energieberatungsservices informiert zu werden. Ich bin einverstanden, dass febis meine Angaben gemäß dieser Einwilligungserklärung verarbeiten und nutzen darf.
            Die Kontaktaufnahme kann per Email oder telefonisch erfolgen. Diese Einwilligungserklärung kann ich jederzeit mit Wirkung für die Zukunft widerrufen.
          </span>
        </label>

        <div 
          role="button" 
          aria-label="Jetzt registrieren" 
          aria-disabled={valid()}
          tabIndex={0}
          className={"btn doi-submit-button step_buttons__button btn--print step_buttons__next " + (!valid() ? "btn--disabled" : "")}
          onClick={async ()=>{
            if (valid()){
              setLoading(true);
              setSuccess(false);
              try {
                await sendDoiMail();
                setSuccess(true);
              } catch (err) {
                alert("Fehler beim Senden der E-Mail.");
              }
              setLoading(false);
            }
          }}
          >
          <span>Jetzt registrieren</span>
        </div>
        </form>);  
  }

export function LeadForm(){
    // const firstname = useQuestionizerStore((state) => state.firstname);
    // const setFirstname = useQuestionizerStore((state) => state.setFirstname);
    // const lastname = useQuestionizerStore((state) => state.lastname);
    // const setLastname = useQuestionizerStore((state) => state.setLastname);
    // const email = useQuestionizerStore((state) => state.email);
    // const setEmail = useQuestionizerStore((state) => state.setEmail);
    const dataprotection = useQuestionizerStore((state) => state.dataprotection);
    const step = useQuestionizerStore((state) => state.step);
    const stepsCount = useQuestionizerStore((state) => state.stepsCount());
    const setDataprotection = useQuestionizerStore((state) => state.setDataprotection);

    const setSendDetails = useQuestionizerStore((state) => state.setSendDetails);
    const send_complete = useQuestionizerStore((state) => state.send_complete);
    const setCallBack = useQuestionizerStore((state) => state.setCallBack);
    const call_back = useQuestionizerStore((state) => state.call_back);
    const setCall9 = useQuestionizerStore((state) => state.setCall9);
    const call9 = useQuestionizerStore((state) => state.call9);
    const setCall13 = useQuestionizerStore((state) => state.setCall13);
    const call13 = useQuestionizerStore((state) => state.call13);

    const tel = useQuestionizerStore((state) => state.tel);
    const setTel = useQuestionizerStore((state) => state.setTel);
    const updateValidation = useQuestionizerStore((state) => state.updateValidation);

    const request_lead = useQuestionizerStore((state) => state.request_lead);
    const lead_sended = useQuestionizerStore((state) => state.lead_sended);

    const gewerke_lables = useQuestionizerStore((state) => state.getGewerkLabels());
    const gewerke_mit_telefon = [
      "Wärmepumpe", "Holz-Pelletheizung", "Solarthermie", "Nah-/Fernwärme", "Brennstoffzelle",
      "Energieberatung", "Wanddämmung", "Dachdämmung", "Kellerdämmung", "Fassadensanierung", "Dachsanierung",
      "Wärmeschutz", "Dachfenster", "Lüftungsanlage"
    ];

    const show_phone = gewerke_mit_telefon.some((g) => gewerke_lables.includes(g));

    console.log("lead_sended:",lead_sended, " show_phone: ",show_phone, gewerke_lables);
    if (!show_phone){
      return <></>;
    }

    if (lead_sended){
      return <div className="space-y-4 mb-8 bg-neutral p-8">
        <h2 role="alert" className="mt-0 text-center">Formular erfolgreich gesendet.</h2>
      </div>;
    }

    const onBlur = () => {};

    const valid = () => dataprotection == true &&
      tel &&  tel?.length > 5;

    return (<form className="space-y-4 mb-8 bg-neutral p-8" role="group" aria-labelledby="lead-form-title" aria-describedby="lead-form-description">
      <h2 id="lead-form-title" className="mt-0">Beratung anfordern</h2>
      <br></br>
      <b id="lead-form-description">Sie möchten sich den Zuschuss vom Staat sichern? Wir unterstützen Sie dabei Ihre BEG-Bundesförderung stressfrei zu erhalten!
      Geben Sie Ihre Tel.-Nr. an und wir kontaktieren Sie persönlich.</b>
     
     <Input<number> required label="Tel.-Nr." value={tel} onBlur={onBlur} onChange={(value)=>{
        setTel(value);
        updateValidation();
      }} type="phone"/>

          {/* <label className="flex">
            <Checkbox value={call_back == true} onBlur={onBlur} onChange={(value)=>{
              setCallBack(value);
              updateValidation();
            }}/>		
            <span><b>Sie möchten den Zuschuss vom Staat sicher und stressfrei erhalten? Wir unterstützen Sie dabei!</b> Geben Sie Ihre Tel.-Nr. an und wir kontaktieren Sie persönlich.</span>
          </label> */}

          <fieldset className="flex space-x-4">
          <legend>Wann sind Sie am besten erreichbar?</legend>
            <label className="flex items-center">
            <Checkbox value={call9 == true} onBlur={onBlur} onChange={(value)=>{
              setCall9(value);
              updateValidation();
            }}/>		
            9-13 Uhr
          </label>
          <label className="flex items-center">
            <Checkbox value={call13 == true} onBlur={onBlur} onChange={(value)=>{
              setCall13(value);
              updateValidation();
            }}/>	
            13-17 Uhr	
          </label>
          </fieldset>

        {/* <label className="flex ">
          <Checkbox value={dataprotection == true} onBlur={onBlur} onChange={(value)=>{
            setDataprotection(value);
            updateValidation();
          }}/>		
          <span>
            Es gelten unsere <a target="_blank" href="https://foerderdata.de/datenschutzerklaerung/">Datenschutzbestimmungen</a>. Ja, ich bin einverstanden, von febis über Förder- und Energieberatungsservices informiert zu werden. Ich bin einverstanden, dass febis meine Angaben gemäß dieser Einwilligungserklärung verarbeiten und nutzen darf.
            Die Kontaktaufnahme kann per Email oder telefonisch erfolgen. Diese Einwilligungserklärung kann ich jederzeit mit Wirkung für die Zukunft widerrufen.
          </span>
        </label> */}

        <div 
          role="button" 
          aria-label="Jetzt E-Mail anfordern" 
          aria-disabled={valid()}
          tabIndex={0}
          className={"btn doi-submit-button step_buttons__button btn--print step_buttons__next " + (!valid() ? "btn--disabled" : "")}
          onClick={()=>{
            valid() && request_lead(1);
          }}
          >
          <span>Jetzt Rückruf anfordern</span>
        </div>
        </form>);  
  }